import React from "react";
import { Tab } from "@headlessui/react";
import { classNames } from "../../../../../helpers/functions";
import AMRMedicationList from "./AMRMedicationList";
import { drugTypes } from "../../service-steps/clinical-assessment/data";

const AMRPreReviewPrescriptionSection = ({
  filteredMedication,
  reviewedMedicationCards,
  showPrescriptionMeds,
  setShowPrescriptionMeds,
  onMedicationClick,
  onMenuAction,
  onExpandMedication,
  expandedMedications,
  hoveredMed,
  onMouseEnter,
  onMouseLeave,
  menuMedication,
  onMenuOpen,
  showMenu,
  menuData,
  selectedMedication,
  isMatchingDrug,
  medicationDetails,
  getNoRecordMessage,
  getCardFromDrug,
  selectMedication,
  medications = [],
}) => {
  const prescriptionMeds = medications.filter(
    (med) => med.medicationType === drugTypes.Prescription && med.status === "active"
  );
  
  const reviewedMedNames = reviewedMedicationCards
    .filter((card) => card.status === "reviewed" || card.status === "skipped")
    .map((card) => card.name);
  
  const isCompleted = prescriptionMeds.length > 0 && prescriptionMeds.every((med) =>
    reviewedMedNames.includes(med.displayName)
  );

  return (
    <Tab.Group>
      <Tab.Panels className="">
        <Tab.Panel
          className={classNames(
            "rounded-xl bg-white",
            "ring-white ring-opacity-60 ring-offset-2 focus:outline-none focus:ring-2"
          )}
        >
          <AMRMedicationList
            filteredMedication={filteredMedication}
            reviewedMedicationCards={reviewedMedicationCards}
            medicationType={drugTypes.Prescription}
            title="Prescriptions"
            isExpanded={showPrescriptionMeds}
            onToggleExpanded={() => setShowPrescriptionMeds(!showPrescriptionMeds)}
            expandedMedications={expandedMedications}
            hoveredMed={hoveredMed}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            menuMedication={menuMedication}
            onMenuOpen={onMenuOpen}
            selectedMedication={selectedMedication}
            onExpandMedication={onExpandMedication}
            medicationDetails={medicationDetails}
            getNoRecordMessage={getNoRecordMessage}
            getCardFromDrug={getCardFromDrug}
            selectMedication={selectMedication}
            isCompleted={isCompleted}
          />
        </Tab.Panel>
      </Tab.Panels>
    </Tab.Group>
  );
};

export default AMRPreReviewPrescriptionSection;
